import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { formatIDR, TIER_META } from "@/lib/format";
import { Loading, TierBadge, Modal } from "@/components/kit";
import { HscLogo } from "@/components/HscLogo";

export default function Card() {
  const { user } = useAuth();
  const [member, setMember] = useState(null);
  const [zoom, setZoom] = useState(false);

  useEffect(() => { api.getMember(user.member_id).then(setMember).catch(() => {}); }, [user.member_id]);
  if (!member) return <Loading />;

  const meta = TIER_META[member.tier] || TIER_META.Bronze;
  const qrValue = `HSC-${member.id}-${member.tier}`;

  return (
    <div className="space-y-5 fade-in">
      <div>
        <div className="hsc-label">Member Card</div>
        <h1 className="font-display text-3xl text-white">Kartu Digital</h1>
      </div>

      <div className="rounded-3xl border p-6" style={{ background: meta.bg, borderColor: meta.border }}>
        <div className="flex items-center justify-between">
          <HscLogo size="text-lg" />
          <TierBadge tier={member.tier} />
        </div>
        <div className="mt-6 flex flex-col items-center">
          <button onClick={() => setZoom(true)} className="rounded-2xl bg-white p-4" data-testid="member-qr">
            <QRCode value={qrValue} size={168} bgColor="#ffffff" fgColor="#000000" />
          </button>
          <div className="mt-4 font-display text-xl text-white">{member.name}</div>
          <div className="text-[11px] uppercase tracking-widest text-[#8E8E93]">Tap QR untuk perbesar</div>
        </div>
        <div className="mt-6 flex justify-between border-t border-white/10 pt-4">
          <div><div className="hsc-label">Poin</div><div className="font-display text-lg" style={{ color: meta.accent }}>{member.points}</div></div>
          <div className="text-right"><div className="hsc-label">Belanja</div><div className="font-display text-lg text-white">{formatIDR(member.lifetime_spend)}</div></div>
        </div>
      </div>

      <Modal open={zoom} onClose={() => setZoom(false)} maxWidth="max-w-xs">
        <div className="flex flex-col items-center">
          <div className="rounded-2xl bg-white p-5"><QRCode value={qrValue} size={240} /></div>
          <div className="mt-4 font-display text-lg text-white">{member.name}</div>
        </div>
      </Modal>
    </div>
  );
}
